export default __webpack_public_path__ + "static/media/abou.e0466d29.png";